import React, { type FC } from 'react'
import { useIntl } from 'react-intl'
import {
  Button,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
} from 'mailup-web-components'
import { useAtom } from 'jotai'
import { filterFormAtom, goToRecipientModalAtom } from '../state/state'
import {
  goToRecipientsCallback,
  saveAndGoToRecipientsCallback,
} from '../callbacks/form'
import { useAtomCallback } from 'jotai/utils'

const ModalGoToRecipients: FC = () => {
  const intl = useIntl()

  const [{ show }, setModal] = useAtom(goToRecipientModalAtom)
  const [filter] = useAtom(filterFormAtom)
  const saveAndGoToRecipients = useAtomCallback(saveAndGoToRecipientsCallback)
  const goToRecipients = useAtomCallback(goToRecipientsCallback)

  const handleCancelModal = (): void => {
    setModal({ show: false })
  }

  return (
    <Modal show={show} onClose={handleCancelModal} closeOnOverlayClick>
      <ModalHead
        title={intl.formatMessage({ id: 'Load.Common.ChangesNotSaved' })}
      />
      <ModalBody>
        {intl.formatMessage({ id: 'Load.Filters.ModalGoToSubscribersDescr' })}
      </ModalBody>
      <ModalFoot>
        {filter.Id !== 0 && (
          <Button kind='primary' onClick={goToRecipients}>
            {intl.formatMessage({
              id: 'Load.CombinedFilterForm.IgnoreAndGoToRecipients',
            })}
          </Button>
        )}
        <Button kind='secondary' onClick={saveAndGoToRecipients}>
          {intl.formatMessage({
            id: 'Load.CombinedFilterForm.SaveAndGoToRecipients',
          })}
        </Button>
        <Button kind='secondary' onClick={handleCancelModal}>
          {intl.formatMessage({ id: 'Load.MailupCommon.Cancel' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalGoToRecipients
